import { downloadObjectAsJson, getFileStructure, readJsonFile } from './utils';
import * as Mutations from './mutations';

export default {
  editGeneratedItem({ commit, state: { generatedItems } }, uuid) {
    commit(Mutations.SET_ITEM_DATA, generatedItems[uuid]);
  },
  async importGeneratedItems({ commit }, file) {
    const importedItems = await readJsonFile(file);

    commit(Mutations.MERGE_IMPORTED_ITEMS, importedItems);
  },
  async exportGeneratedItems({ state: { generatedItems } }) {
    let items = {...generatedItems}

    // eslint-disable-next-line no-undef
    const exportWithImages = await swal({
      title: 'Deseja incluir as imagens na exportação?',
      text: 'Isso pode incrementar drásticamente o tamanho do arquivo!',
      icon: 'warning',
      buttons: ['Exportar apenas textos', 'Exportar imagens']
    })

    if (!exportWithImages) {
      for (const itemId in items) {
        delete items[itemId]['file']
        delete items[itemId]['image']
      }
    }

    downloadObjectAsJson(items, 'artefatos')
  },
  setGeneratedItem({ commit }, image) {
    commit(Mutations.SET_GENERATED_ITEM, image);
    commit(Mutations.RESET_ITEM_DATA);
  },
  async setItemFile({ commit }, rawFile) {
    const file = await getFileStructure(rawFile);

    commit(Mutations.SET_ITEM_FILE, file);
  }
}